import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff',
    whiteSpace: 'pre-wrap'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  setPropTypes(propTypes),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    editAction,
    editConfirm,
    openApprovalProgress,
    progressOkAction,
    loading,
    resultMessage
  }) => {
    return (
      <div className={classes.root}>
        <Typography variant="h6">本人確認書類審査確認</Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableRow>
              <TableCell className={classes.tableCellItem}>審査結果</TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.approvalResultStr}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>NG理由</TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.ngReason}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                事務局メモ
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.adminMemo}
              </TableCell>
            </TableRow>
            {/* <TableRow>
              <TableCell className={classes.tableCellItem}>店舗種別</TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.shopFoodApprovedResultStr}
              </TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell className={classes.tableCellItem}>口座名義</TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.bankAccountHolder}
              </TableCell>
            </TableRow>
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={editAction} />
        </div>
        <ProgressDialog
          openProgress={openApprovalProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
